
import Vue from "vue";
import AppCreateUblArchiveModalWrapper from "./CreateUblArchiveModalWrapper.vue";
import {Job} from "@/models/job";

export default Vue.extend({
	props: {
		isPurchase: Boolean,
		job: Object as ()=>Job
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppCreateUblArchiveModalWrapper
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
